import { IconButton, PlusIcon } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import { GnbMenu } from "@/components/base";
import { DatasetUploadButton } from "@/components/dataset/DatasetUploadButton";
import { PageBase, type PageBaseProps } from "@/page/base/PageBase";
import { UploadJobsPanel } from "./UploadJobsPanel";
import { DiagnosticJobsPanel } from "./DiagnosticJobsPanel";
import { WorkerStatusPanel } from "./WorkerStatusPanel";
import { WorkerJobFilterBar } from "./WorkerJobFilterBar";
import { WorkerSettingsButton } from "./WorkerSettingsButton";
import { openDiagnosticSubmitWindow } from "./diagnosticSubmitWindow";
import {
  uploadJobsChangedEvent,
  useWorkerOperationsController,
} from "./useWorkerOperationsController";

export function AdminWorkerStatusPage() {
  const { tab, setTab } = useWorkerOperationsController();
  return (
    <AdminWorkerOperationsView
      pageTitle="Workers"
      currentMenu={GnbMenu.AdminWorkers}
      requiredRoles={["admin"]}
      scrollable={false}
      bodyFlushTop
      tabs={{
        items: [
          { value: "workers", label: "Worker" },
          { value: "uploads", label: "업로드 큐" },
          { value: "diagnostics", label: "진단 큐" },
        ],
        value: tab,
        onValueChange: setTab,
        ariaLabel: "Worker 운영 탭",
      }}
      headerActions={
        tab === "workers" ? (
          <WorkerSettingsButton />
        ) : tab === "uploads" ? (
          <DatasetUploadButton
            onClosed={() => window.dispatchEvent(new Event(uploadJobsChangedEvent))}
          />
        ) : (
          <IconButton
            text="진단 작업 추가"
            variant="solid"
            onClick={() => openDiagnosticSubmitWindow()}
          >
            <PlusIcon />
          </IconButton>
        )
      }
      belowTabs={
        tab === "workers" ? null : <WorkerJobFilterBar diagnostic={tab === "diagnostics"} />
      }
    />
  );
}

class AdminWorkerOperationsView extends PageBase<PageBaseProps> {
  protected override renderContent(): ReactNode {
    if (this.props.tabs?.value === "uploads") return <UploadJobsPanel />;
    if (this.props.tabs?.value === "diagnostics") return <DiagnosticJobsPanel />;
    return <WorkerStatusPanel />;
  }
}
